module.exports = "/_next/static/images/logo-4c99e6873469725a8c9060e34c0b8b7d.svg";